import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CategoryService } from 'app/services/models/category.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CategoryListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any[] = [];
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption = 5;
  public searchValue = '';
  totalCount: number = 0;
  public ColumnMode = ColumnMode;
  constructor(private categoryService: CategoryService, private _coreSidebarService: CoreSidebarService) { }

  async ngOnInit() {
    this.categoryService.event$.subscribe(async result => {
      await this.getAllCategories(this.searchValue, this.pageBasic - 1, this.selectedSize);

    })
    await this.getAllCategories(this.searchValue, this.pageBasic - 1, this.selectedSize);

  }

  async sendEvent() {
    await this.getAllCategories(this.searchValue, this.pageBasic - 1, this.selectedSize);
  }

  async filterUpdate(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchValue = input.value.toLowerCase();
    await this.getAllCategories(this.searchValue, this.pageBasic - 1, this.selectedSize);
  }

  async getAllCategories(search: string, page: number, size: number) {
    this.blockUI.start();
    try {
      const data = await this.categoryService.getAllCategories(page, size, search);
      console.log(data);
      this.rows = data.categories;
      this.totalCount = data.totalCount;
    } catch (error) {
      console.error('Error fetching currencies:', error);
    }
    this.blockUI.stop();
  }


  async onPageChange() {
    await this.getAllCategories(this.searchValue, this.pageBasic - 1, this.selectedSize);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption);
    await this.getAllCategories(this.searchValue, this.pageBasic - 1, this.selectedSize);
  }

  selectedCategory: any;
  toggleSidebar(name, row): void {
    this.selectedCategory = row;
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

}
